import { render, staticRenderFns } from "./tableColumn.vue?vue&type=template&id=144e82bf&scoped=true"
import script from "./tableColumn.vue?vue&type=script&lang=js"
export * from "./tableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e82bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144e82bf')) {
      api.createRecord('144e82bf', component.options)
    } else {
      api.reload('144e82bf', component.options)
    }
    module.hot.accept("./tableColumn.vue?vue&type=template&id=144e82bf&scoped=true", function () {
      api.rerender('144e82bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/airTransport/pushConfiguration/cmp/tableColumn.vue"
export default component.exports